module.exports = __webpack_public_path__ + "static/media/image-1.6001910c.png";